import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from "vuex";
import { SAVE_CURRENT_CAMPAIGN } from "../../store/drip-campaign-actions";
import CampaignSubjectSection from "@Broker/@Modules/marketing/components/campaigns/campaign-subject-section";
import TimePicker from "@Broker/@Modules/automation/automation/components/argument-types/time";
import NumericInput from "@Shared/components/inputs/numeric-input";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import MaterialInput from "@Shared/components/inputs/material-input";
import RadioSection from "@Shared/components/sections/radio-section";
import DripCampaignEmailStatistics from "./drip-campaign-email-statistics";
import DripCampaignTemplateSelect from "./drip-campaign-template-select";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignSingleEmail",
  components: {
    CampaignSubjectSection,
    TimePicker,
    NumericInput,
    MaterialInput,
    InlinePrompt,
    DripCampaignEmailStatistics,
    RadioSection,
    DripCampaignTemplateSelect
  },
  props: {
    stage: {
      type: Object,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    // eslint-disable-next-line vue/prop-name-casing
    $v: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isCustomDaysToWait: false
    };
  },
  computed: {
    waitDays() {
      return [{
        label: this.$tc("global.messages.qtyDays", 1),
        value: 1
      }, {
        label: this.$tc("global.messages.qtyDays", 2, {
          qty: 2
        }),
        value: 2
      }, {
        label: this.$tc("global.messages.qtyDays", 2, {
          qty: 3
        }),
        value: 3
      }, {
        label: this.$tc("global.messages.qtyDays", 2, {
          qty: 4
        }),
        value: 4
      }, {
        label: this.$tc("global.messages.qtyDays", 2, {
          qty: 5
        }),
        value: 5
      }, {
        label: this.$tc("global.messages.qtyDays", 2, {
          qty: 6
        }),
        value: 6
      }, {
        label: this.$tc("global.messages.qtyWeeks", 1),
        value: 7
      }, {
        label: this.$tc("global.messages.qtyWeeks", 2, {
          qty: 2
        }),
        value: 14
      }, {
        label: this.$tc("global.messages.qtyWeeks", 2, {
          qty: 3
        }),
        value: 21
      }, {
        label: this.$tc("global.messages.qtyWeeks", 2, {
          qty: 4
        }),
        value: 28
      }, {
        label: this.$tc("global.messages.qtyMonths", 1),
        value: 30
      }, {
        label: this.$tc("global.messages.qtyMonths", 2, {
          qty: 3
        }),
        value: 90
      }, {
        label: this.$tc("global.messages.qtyMonths", 2, {
          qty: 6
        }),
        value: 180
      }, {
        label: this.$tc("global.messages.qtyMonths", 2, {
          qty: 9
        }),
        value: 270
      }, {
        label: this.$tc("global.messages.qtyYears", 1),
        value: 365
      }, {
        label: this.$t("global.words.custom"),
        value: 0
      }];
    },
    daysToWaitDropdownText() {
      var _this$dayToWait;
      if (this.daysToWaitIsZero && !this.isCustomDaysToWait) return this.$tc("global.messages.qtyDays", 2, {
        qty: "X"
      });
      if (this.isCustomDaysToWait) return this.$t("global.words.custom");
      return ((_this$dayToWait = this.dayToWait) == null ? void 0 : _this$dayToWait.label) || this.$t("global.words.custom");
    },
    dayToWait() {
      var _context;
      return _findInstanceProperty(_context = this.waitDays).call(_context, duration => duration.value === this.stage.daysToWait);
    },
    daysToWaitIsZero() {
      return this.stage.daysToWait === 0;
    },
    isSendInstantly() {
      return this.daysToWaitIsZero && !this.isCustomDaysToWait;
    },
    isFirstEmail() {
      return this.index === 0;
    },
    subjectData() {
      return {
        subject: this.stage.subject,
        previewText: this.stage.previewText
      };
    },
    defaultTimeToSendAt() {
      return "12:00:00 am";
    },
    timeToSendAt() {
      return this.stage.timeToSendAt || this.defaultTimeToSendAt;
    },
    subjectCustomExpressions() {
      return {
        previewText: `currentCampaign.stages.$each[${this.index}].previewText`,
        subject: `currentCampaign.stages.$each[${this.index}].subject`
      };
    },
    hasStatistics() {
      return this.stage.statistics;
    },
    coApplicantsSendOptions() {
      return [{
        label: this.$t("drip-campaigns.stages.editEmails.copyForCoapplicants"),
        value: "cc-coapplicants"
      }, {
        label: this.$t("drip-campaigns.stages.editEmails.separateEmail"),
        value: "separate-email"
      }];
    },
    selectedCoApplicantsSendOption() {
      return this.stage.ccCoApplicants ? "cc-coapplicants" : this.stage.sendAsSeparate ? "separate-email" : null;
    }
  },
  mounted() {
    this.isCustomDaysToWait = this.isFirstEmail && this.daysToWaitIsZero ? false : !this.dayToWait;
  },
  methods: _objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [SAVE_CURRENT_CAMPAIGN])), {}, {
    handleChangeDaysToWait({
      value,
      label
    }) {
      this.isCustomDaysToWait = label && value === 0 || label === "custom-option";
      if (this.isCustomDaysToWait && value === 0) value = 1;
      const data = {
        daysToWait: _parseInt(value)
      };
      this.$emit("stage-change", data);
    },
    handleChangeTime(val) {
      const data = {
        timeToSendAt: val
      };
      this.$emit("stage-change", data);
    },
    handleTemplateDelete() {
      const data = {
        templateId: "",
        templateName: "",
        templateThumbnail: ""
      };
      this.$emit("stage-change", data);
    },
    handleSubjectChange(data) {
      this.$emit("stage-change", data);
    },
    handleDelete() {
      this.$emit("stage-delete");
    },
    handleSendCoApplicantsChange(value) {
      const data = {
        ccCoApplicants: value === "cc-coapplicants",
        sendAsSeparate: value === "separate-email"
      };
      this.$emit("stage-change", data);
    }
  })
});